export const ALL_ITEMS = [
    {
        label: 'Select One',
        value: '',
    },
    {
        label: "Crizal",
        value: process.env.REACT_APP_CRIZAL
    },
    {
        label: "Disease and Conditions",
        value: process.env.REACT_APP_DISEASE
    },
    {
        label: "EyeZen",
        value: process.env.REACT_APP_EYEZEN
    },
    // {
    //     label: "Instruments",
    //     value: process.env.REACT_APP_INSTRUMENTS
    // },
    // {
    //     label: "Light Management",
    //     value: process.env.REACT_APP_LIGHT_MANAGEMENT
    // },
    // {
    //     label: "Measuring Devices",
    //     value: process.env.REACT_APP_MEASURING_DEVICES
    // },
    // {
    //     label: "Myopia",
    //     value: process.env.REACT_APP_MYOPIA
    // },
    // {
    //     label: "Presbyopia",
    //     value: process.env.REACT_APP_PRESBYPIA
    // },
    // {
    //     label: "Refraction",
    //     value: process.env.REACT_APP_REFRACTION
    // },
    {
        label: "Stellest",
        value: process.env.REACT_APP_STELLEST
    },
    {
        label: "Transitions",
        value: process.env.REACT_APP_TRANSITIONS
    },
    {
        label: "Varilux",
        value: process.env.REACT_APP_VARILUX
    },
];
